import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledVideo = styled.video.withConfig({
  displayName: "Video__StyledVideo",
  componentId: "sc-1rj7lg3-0"
})(["max-width:100%;"]);
const Video = ({
  src,
  loop,
  autoplay,
  controls,
  height,
  width
}) => {
  return /*#__PURE__*/_jsx(StyledVideo, {
    src: src,
    autoPlay: autoplay,
    controls: controls,
    loop: loop,
    height: height,
    width: width,
    children: /*#__PURE__*/_jsx("source", {
      src: src,
      type: "video/mp4"
    })
  });
};
export default Video;